import { Text, useStyleConfig } from '@tectonic/elemason-components';
import clsx from 'clsx';
import { Button } from '../../Button';
import { ProductReviewCard } from './ProductReviewCard';

import type {
  ElemasonButtonData,
  ElemasonProductReviewsWidget,
  ProductReview,
} from '@tectonic/types';
import type { FC } from 'react';

type ProductReviewsProps = {
  isError?: boolean;
  isLoading?: boolean;
  config?: ElemasonProductReviewsWidget['config'];
  data?: ProductReview[];
  paginationButtonData?: ElemasonButtonData;
  icon: string;
  total?: number;
  title?: string;
  hasNextPage?: boolean;
  getNext?: () => void;
};

const ProductReviews: FC<ProductReviewsProps> = ({
  data,
  paginationButtonData,
  config,
  title,
  total,
  icon,
  getNext,
  hasNextPage,
  isError,
  isLoading,
}) => {
  if (!data || !total || total === 0 || data.length === 0) {
    return null;
  }

  const { style, className } = useStyleConfig(config?.container ?? {});

  const { style: reviewsCountContStyle, className: reviewsCountContClassName } =
    useStyleConfig(config?.reviewsCount?.container ?? {});

  return (
    <div style={style} className={clsx('flex flex-col', className)}>
      <div
        className={clsx('flex flex-col', reviewsCountContClassName)}
        style={reviewsCountContStyle}
      >
        <Text
          data={title ?? `Reviews ({total})`}
          placeholders={{ total }}
          config={config?.reviewsCount?.text}
        />
      </div>
      <div className="flex flex-col">
        {data.map((review) => (
          <ProductReviewCard
            key={`review-${review.id}`}
            config={config}
            data={review}
            icon={icon}
          />
        ))}
      </div>
      {hasNextPage ? (
        <div className="flex flex-col">
          <Button
            // disabled={isLoading || isError}
            config={config?.paginateButton?.button}
            data={paginationButtonData}
            onClick={getNext}
          />
        </div>
      ) : (
        <div className="flex flex-col p-3">
          <Text
            config={{
              variant: 'body3',
              color: 'primary-900',
              textAlign: 'center',
            }}
            data="No more reviews to show"
          />
        </div>
      )}
    </div>
  );
};

export { ProductReviews };
